import type { ReactElement } from 'react';

import { cn } from './utils';

export interface MaskIconProps {
  src: string;
  size: number;
  className?: string;
}

/**
 * `src` is an inlined SVG data URI, and the markup inside it carries quotes —
 * Vite emits `width='16'`, tsup emits `width="16"`. An UNQUOTED CSS `url()`
 * token may not contain either, so `url(${src})` is rejected by the parser,
 * `mask-image` falls back to `none`, and the span paints its whole
 * `currentColor` background: a solid black square where the icon should be.
 *
 * Quoting the token fixes it, and escaping the one character that would close
 * the quote early keeps it fixed whichever bundler produced the URI.
 */
function cssUrl(src: string): string {
  return `url("${src.replace(/"/g, '%22')}")`;
}

export function MaskIcon({ src, size, className }: MaskIconProps): ReactElement {
  const maskImage = cssUrl(src);
  return (
    <span
      aria-hidden="true"
      className={cn('inline-block shrink-0', className)}
      style={{
        width: size,
        height: size,
        backgroundColor: 'currentColor',
        WebkitMaskImage: maskImage,
        maskImage,
        WebkitMaskRepeat: 'no-repeat',
        maskRepeat: 'no-repeat',
        WebkitMaskSize: 'contain',
        maskSize: 'contain',
        WebkitMaskPosition: 'center',
        maskPosition: 'center',
      }}
    />
  );
}
